import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Placeholder from "@/pages/Placeholder";
import Pricing from "@/pages/Pricing";
import Security from "@/pages/Security";
import Undertaking from "@/pages/Undertaking";
import Faq from "@/pages/Faq";
import Stories from "@/pages/Stories";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Accused from "@/pages/Accused";
import Missing from "@/pages/Missing";
import Altercations from "@/pages/Altercations";
import AdminLeads from "@/pages/AdminLeads";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/accused" element={<Accused />} />
          <Route path="/missing" element={<Missing />} />
          <Route path="/altercations" element={<Altercations />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/security" element={<Security />} />
          <Route path="/undertaking" element={<Undertaking />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route
            path="*"
            element={
              <Placeholder
                kicker="Not found"
                title="This page has not been written yet."
                description="Use the header to head back home or install the app."
              />
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
